import { render, staticRenderFns } from "./TermList.vue?vue&type=template&id=4ca57818"
import script from "./TermList.vue?vue&type=script&lang=js"
export * from "./TermList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports